export default __webpack_public_path__ + "static/media/6.8a33b130.png";